import React from "react";
import { Outlet, useLocation } from "react-router-dom";

function Integrations() {
  const location = useLocation();
  const isIndex =
    location.pathname === "/admin/integrations" ||
    location.pathname === "/admin/integrations/";

  return (
    <div style={{ padding: "4px 2px" }}>
      {isIndex ? (
        <div className="adminCard">
          <div className="adminCardHeader">
            <h2 className="adminCardTitle">Integrations</h2>
            <div className="adminCardSubtitle">
              Selecciona una opcion en el menu lateral para empezar.
            </div>
          </div>
          <div className="adminCardInner" style={{ color: "rgba(230,230,247,0.78)" }}>
            <div style={{ marginBottom: 10 }}>
              - Channel Managers: conecta OTAs y sincronizacion.
              <br />- Payment Gateways: configuracion de Stripe Connect.
              <br />- CRM Providers: telefonia, mensajeria y actividad comercial.
              <br />- POS y Compras: vincula el POS de Pilcore o un adaptador externo para sincronizar catálogos completos.
              <br />- WhatsApp Delivery Notes: recepcion de albaranes por business unit.
            </div>
            <div style={{ fontSize: "0.85rem", color: "rgba(230,230,247,0.62)" }}>
              Tip: al pasar el raton por la barra lateral, se despliega para mostrar todas las opciones.
            </div>
          </div>
        </div>
      ) : null}

      <Outlet />
    </div>
  );
}

export default Integrations;
